<template>
  <div>
    <TablePublic :colLists="historyColLists" :tableData="data" :paginationFlag="false">
      <template slot="modificationDesc" slot-scope="scope">
        <div style="white-space: normal; text-align: left">{{ scope.data.modificationDesc }}</div>
        <slot name="modificationDesc_suffix" :data="scope.data"></slot>
      </template>
      <template slot="reason" slot-scope="scope">
        <div style="white-space: normal">{{ scope.data.reason }}</div>
      </template>
    </TablePublic>
  </div>
</template>
<script>
import TablePublic from '@/components/tablePublic.vue'
export default {
  name: 'HistoryRecord',
  components: {
    TablePublic,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const _this = this
    return {
      historyColLists: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'createTime',
          label: '修改日期',
          isTrue: true,
          width: 150,
          formatter(row) {
            return row.createTime ? _this.parseTime(row.createTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: 150,
        },
      ],
    }
  },
  methods: {

  },
}
</script>
